import { AutocompleteInput } from "@/components/admin";
import { useWatch } from "react-hook-form";
import { CITIES_BY_STATE, COUNTRIES, INDIAN_STATES, toChoices } from "./indiaGeo";

// Allow free text alongside the suggestions: typing a value not in the list
// creates it as the selected option instead of being rejected.
const freeText = (value?: string) => {
    const v = value?.trim();
    return v ? { id: v, name: v } : undefined;
};

/**
 * Vendor #22: City / State / Country with offline auto-suggest.
 * City suggestions are scoped to the selected state; any value can still be
 * typed in for entries not present in the bundled list.
 */
export const VendorLocationInputs = () => {
    const state = useWatch({ name: "state" });
    const cityChoices =
        state && CITIES_BY_STATE[state] ? toChoices(CITIES_BY_STATE[state]) : [];

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <AutocompleteInput
                source="state"
                label="State"
                choices={toChoices(INDIAN_STATES)}
                onCreate={freeText}
                className="w-full"
            />
            <AutocompleteInput
                source="city"
                label="City"
                choices={cityChoices}
                onCreate={freeText}
                helperText={state ? false : "Pick a state for city suggestions"}
                className="w-full"
            />
            <AutocompleteInput
                source="country"
                label="Country"
                choices={toChoices(COUNTRIES)}
                defaultValue="India"
                onCreate={freeText}
                className="w-full"
            />
        </div>
    );
};
